import R from 'ramda'

const LIKE_DISPLAY_TYPE = 'Like'
const NEW_TWEET_ACTION = 'NEW_TWEET'
const EXISTING_TWEET_ACTION = 'EXISTING_TWEET'
const INITIAL_TWEET_TRIGGER_TYPE = 'INITIAL_TWEET'
const LIKE_OF_TRIGGER_TYPE = 'LIKE_OF'

const isLikeFormTrigger = R.propEq('type', LIKE_DISPLAY_TYPE)

const getType = R.cond([
  [R.propEq('action', NEW_TWEET_ACTION), R.always(INITIAL_TWEET_TRIGGER_TYPE)],
  [R.propEq('action', EXISTING_TWEET_ACTION), R.always(LIKE_OF_TRIGGER_TYPE)]
])

const getResult = R.cond([
  [R.propEq('action', NEW_TWEET_ACTION), R.always(LIKE_OF_TRIGGER_TYPE)]
])

const convertLikeFormTriggerToWidgetTrigger = R.applySpec({
  type: getType,
  result: getResult,
  data: R.prop('value'),
  attachmentUrl: R.prop('attachmentUrl'),
  cardUri: R.prop('cardUri'),
  media: R.prop('media'),
  operator: R.always('AND'),
  primary: R.T,
  isPromotedTweet: R.prop('isPromotedTweet')
})

export { isLikeFormTrigger, convertLikeFormTriggerToWidgetTrigger }



// WEBPACK FOOTER //
// ./src/pages/widgets/mapping/triggers/twitter/form-to-widget/like.js